@if (sasLangData !== null && sasLangData!.length > 1) {
  <div ngbDropdown class="d-inline-block" display="dynamic">
    <button type="button" class="btn btn-outline-primary d-flex align-items-center gap-3" id="languageDropdown" ngbDropdownToggle>
      <i class="bi bi-globe" aria-hidden="true"></i>
      {{ languageSelected!.code | translate }}
    </button>
    <div ngbDropdownMenu aria-labelledby="languageDropdown">
      <div ngbDropdownItem
           [class.disabled]="true"
           aria-disabled="true"
           class="select-language text-black">
        {{ 'SELECT_LANGUAGE' | translate }}
      </div>
      <hr class="dropdown-divider">
      @for (item of sasLangData; track item.code) {
        <button ngbDropdownItem (click)="changeLanguage(item.value)" class="d-flex justify-content-between">
          {{ item.code | translate }}
           @if (item.code === languageSelected!.code) {
            <i class="bi bi-check2"></i>
          }
         </button>
      }
    </div>
  </div>
}
